import React, { useEffect } from "react";
import logo from "../../assets/glip_square.svg";
import styled from "styled-components";
import BlueButton from "./BlueButton";

const Nav = styled.div`
  background: rgba(21, 21, 29, 1);
  padding: 12px 120px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const HorizontalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export default function Navbar() {
  return (
    <Nav>
      <HorizontalWrapper>
        <img src={logo} />
        <label style={{ marginLeft: 16, fontFamily: "Poppins", fontSize: 20 }}>
          !glip
        </label>
      </HorizontalWrapper>
      <HorizontalWrapper>
        <a
          style={{ marginRight: 32, fontSize: 14 }}
          href={
            "https://glip.gg/pc"
          }
        >
          Download pc app
        </a>
        <BlueButton  href={
            "https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US"
          } rounded={true}>Download android app</BlueButton>
      </HorizontalWrapper>
    </Nav>
  );
}
